define('responsive-pitch-fx/lib/workers/Pitch',['require','exports','module','./PitchRaster','./PitchShader'],function(require,exports,module){
    var UNDEFINED;

	var PitchRaster = require( './PitchRaster' ),
		PitchShader = require( './PitchShader' );

	function Pitch(pitch,renderer){
        var stats   = pitch.stats || pitch,
            details = pitch.details || pitch;

		this.pitch=pitch;
        this.isPitch = !!pitch.isPitch;
        this.is3DPitch = !!(pitch.y0 && pitch.x0 && pitch.z0);
        this.details = details;
        this.stats = stats;
        this.nastyFactor = stats.nastyFactor || pitch.nasty;
        this.startSpeed = stats.startSpeed || pitch.startSpeed;
        this.endSpeed = stats.endSpeed || pitch.endSpeed;
        this.breaks = stats.breaks || pitch;
        this.type = details.type || pitch.type;
        this.displayName = details.displayName || pitch.pitchDisplayName || "";
        this.des = pitch.result && pitch.result.description || pitch.des || "";
        this.coords = stats.coordinates || pitch;
        this.szTop = stats.strikezoneTop || pitch.szTop;
        this.szBot = stats.strikezoneBottom || pitch.szBot;
		this.num=pitch.index || pitch.idx;
        this.renderer=renderer;

		this.raster = new PitchRaster(this,renderer);
		this.shader = new PitchShader(this,renderer);
        
	}

    Pitch.prototype.getPitchColor = function(){
        return this.shader.fill;
    };

    Pitch.prototype.getPitchBallColor = function(){
        return this.shader.ball;
    };

	Pitch.prototype.getArrayOfPoints = function (numberOfPoints) {
        var scalers=this.renderer.scalers,
            timeInterval = ((this.raster.timeAtYPosition(this.renderer.scalers.homePlateFrontY)) / numberOfPoints),
            pointOnScreen,
            points = [],
            currentZ,
            step = 1,
            time,
            color = this.shader.color,
            ballColor = this.shader.fill;

        for (; step <= numberOfPoints; step++) {

            time = step * timeInterval;

            /**
             * Calc x,y,z in pitchFX coords at time and convert to screen space
             * NOTE: Swap y and z and negate y to match CoreAnimation coordinate system
             * TODO: see if this is true for canvas too...
             */
            pointOnScreen = this.raster.points3D(time,step,numberOfPoints);

            if (pointOnScreen===null || pointOnScreen[0] == 0 ||
                pointOnScreen[0] == scalers.width ||
                pointOnScreen[1] == scalers.height - scalers.viewBottomMargin ||
                pointOnScreen[1] == 0) {
                // Pitch has been clipped, end the path here
                break;
            }

            points.push(pointOnScreen);
        }
        if(points && pointOnScreen) {
            this.gradient = this.shader.getGradient(points[0][0], points[0][1], pointOnScreen[0], pointOnScreen[1]);
        }
        return points;
    };

    return Pitch;
});
